import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import BudgetContainer from '../../components/budget-container';
import { isEmpty } from 'lodash';

const budgetKeys = ['small', 'medium', 'major', 'nobudget'];

class BudgetPage extends React.Component {
  renderContent() {
    const { projectsByBudget } = this.props;
    if (isEmpty(projectsByBudget)) return null;
    return budgetKeys.map(key => {
      return (
        <BudgetContainer
          key={key}
          budgetType={key}
          projects={projectsByBudget[key]}
        />
      );
    });
  }

  render() {
    return <div>{this.renderContent()}</div>;
  }
}

const mapStateToProps = state => ({
  projectsByBudget: selectors.getProjectsByBudget(state),
});

BudgetPage.propTypes = {
  projectsByBudget: PropTypes.object,
};

export default connect(mapStateToProps, null)(BudgetPage);



// WEBPACK FOOTER //
// ./src/pages/budget-page/budget-page.js